import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { withStyles, Typography } from "@material-ui/core";
import MultipleElementsInput from '../../Common/InputFields/MultipleElementsInput';
import { isEmail, isPhoneNumber } from './../../../utils/helpers';
import t from "../../../languages/pl";
import withSaveButton from './../../HOC/withSaveButton';
import PaperContainer from "../../Common/PaperContainer";

const useStyles = theme => ({
    container: {
        margin: theme.spacing(1),
        padding: theme.spacing(2)
    },
    form: {
        margin: theme.spacing(2)
    }
});

function validatePhoneWithoutPrefix(number) {
    let result1 = isPhoneNumber(number);
    let pattern = /^\d{9}$/;
    let result2 = pattern.test(number);
    return result1 || result2;
}

const DefaultEmailAndPhoneSettings = props => {
    const { classes, data, onChange } = props;
    const [updatedData, setUpdatedData] = useState(data);

    useEffect(() => {
        setUpdatedData(data);
        props.onFormDataChange(data);
    }, [data]);

    useEffect(() => {
        props.onFormDataChange(updatedData);
        onChange && onChange(updatedData);
    }, [updatedData]);

    return (
        <PaperContainer>
            <Typography variant="subtitle1">
                {t.defaultEmailsAndPhones}
            </Typography>
            <div className={classes.form}>
                <MultipleElementsInput
                    label={t.emailAddressesForReports}
                    inputValidation={isEmail}
                    elements={updatedData.email}
                    onChange={(emails) => setUpdatedData(state => ({ ...state, email: emails}))}
                />
                <MultipleElementsInput
                    label={t.phoneNumberForNotifications}
                    inputValidation={validatePhoneWithoutPrefix}
                    elements={updatedData.telefon}
                    onChange={(phones) => setUpdatedData(state => ({ ...state, telefon: phones}))}
                />
            </div>
        </PaperContainer>
    );
};

DefaultEmailAndPhoneSettings.propTypes = {
    classes: PropTypes.object,
    onChange: PropTypes.func,
    data: PropTypes.object,
    //withSaveButton
    onFormDataChange: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    withSaveButton
)(DefaultEmailAndPhoneSettings);
